export default {"src":"/_next/static/media/gembah-icon.31f230bb.svg","height":20,"width":20};